<mat-dialog-actions>
  <div class="dialog-close">
    <i mat-dialog-close class="fas fa-times"></i>
  </div>
  <div mat-dialog-title>Inspection</div>
</mat-dialog-actions>

<mat-dialog-content>
  <div class="content-container">
    <div class="content-block double-block">
      <div>
        <div class="content-block details">
          <div class="first-text_block">
            <div class="title-left_block">Activity Details</div>
            <div class="text-left_block">Report State</div>
            <div class="text-left_block">Report #</div>
            <div class="text-left_block">Inspection Date</div>
            <div class="text-left_block">Post Date</div>
          </div>
          <div class="second-text_block" *ngIf="!isLoading">
            <div class="text-right_block">
              {{ inspectionDetail.reportState }}
            </div>
            <div class="text-right_block">
              {{ inspectionDetail.reportId }}
            </div>
            <div class="text-right_block">
              {{
                inspectionDetail.inspectionDate
                  ? convertDateFormat(inspectionDetail.inspectionDate)
                  : ""
              }}
            </div>
            <div class="text-right_block">
              {{
                inspectionDetail.postDate
                  ? convertDateFormat(inspectionDetail.postDate)
                  : ""
              }}
            </div>
          </div>
          <div *ngIf="isLoading" class="second-text_block spinner-container">
            <mat-progress-spinner
              mode="indeterminate"
              [diameter]="30"
              class="spinner"
            ></mat-progress-spinner>
          </div>
        </div>
      </div>
      <div>
        <div class="content-block details">
          <div class="first-text_block">
            <div class="title-left_block">Inspection Info</div>
            <div class="text-left_block">Inspection Level</div>
            <div class="text-left_block">Start Time</div>
            <div class="text-left_block">End Time</div>
            <div class="text-left_block">Location</div>
          </div>
          <div class="second-text_block" *ngIf="!isLoading">
            <div class="text-right_block">
              {{
                inspectionDetail?.levelDescription
                  ? inspectionDetail.levelId + " - " + inspectionDetail?.levelDescription
                  : inspectionDetail.levelId
              }}
            </div>
            <div class="text-right_block">
              {{
                inspectionDetail.startTime
                  ? convertTimeStringTo12Hour(inspectionDetail.startTime)
                  : ""
              }}
            </div>
            <div class="text-right_block">
              {{
                inspectionDetail.endTime
                  ? convertTimeStringTo12Hour(inspectionDetail.endTime)
                  : ""
              }}
            </div>
            <div class="text-right_block">
              {{
                inspectionDetail.locationText
                  ? (inspectionDetail.locationText | titlecase)
                  : ""
              }}
            </div>
          </div>
          <div *ngIf="isLoading" class="second-text_block spinner-container">
            <mat-progress-spinner
              mode="indeterminate"
              [diameter]="30"
              class="spinner"
            ></mat-progress-spinner>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block double-block">
      <div>
        <div class="content-block driver">
          <div class="first-text_block">
            <div class="title-left_block">Driver Info</div>
            <div class="text-left_block">Name</div>
            <div class="text-left_block">Driver Id</div>
          </div>
          <div class="second-text_block" *ngIf="!isLoading">
            <div class="text-right_block">
              {{
                inspectionDetail.driver.driverName
                  ? (inspectionDetail.driver.driverName | titlecase)
                  : ""
              }}
            </div>
            <div class="text-right_block">
              {{ inspectionDetail.driver.driverId }}
            </div>
          </div>
          <div *ngIf="isLoading" class="second-text_block spinner-container">
            <mat-progress-spinner
              mode="indeterminate"
              [diameter]="30"
              class="spinner"
            ></mat-progress-spinner>
          </div>
        </div>
      </div>
      <div>
        <div class="content-block driver-second-row">
          <div class="first-text_block">
            <div class="no-title-left_block"></div>
            <div class="text-left_block">License State</div>
            <div class="text-left_block">License #</div>
          </div>
          <div class="second-text_block" *ngIf="!isLoading">
            <div class="text-right_block">
              {{ inspectionDetail.driver.licenseState }}
            </div>
            <div class="text-right_block">
              {{ inspectionDetail.driver.licenseNumber }}
            </div>
          </div>
          <div *ngIf="isLoading" class="second-text_block spinner-container">
            <mat-progress-spinner
              mode="indeterminate"
              [diameter]="30"
              class="spinner"
            ></mat-progress-spinner>
          </div>
        </div>
      </div>
    </div>

    <div class="title-vehicle_block">Vehicle Info</div>

    <div class="container-table">
      <table mat-table [dataSource]="vehicles">
        <ng-container matColumnDef="unit">
          <th mat-header-cell *matHeaderCellDef>Unit</th>
          <td mat-cell *matCellDef="let element">{{ element?.unit }}</td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.unitType ? (element.unitType | titlecase) : "" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="make">
          <th mat-header-cell *matHeaderCellDef>Make</th>
          <td mat-cell *matCellDef="let element">{{ element?.make }}</td>
        </ng-container>

        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef>State</th>
          <td mat-cell *matCellDef="let element">{{ element?.licenseState }}</td>
        </ng-container>

        <ng-container matColumnDef="plate">
          <th mat-header-cell *matHeaderCellDef>Plate #</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.licenseNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="vin">
          <th mat-header-cell *matHeaderCellDef>Vin #</th>
          <td mat-cell *matCellDef="let element">{{ element?.vin }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="vehiclesColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: vehiclesColumns"></tr>
      </table>

      <div *ngIf="isLoading" class="spinner-container-table">
        <mat-progress-spinner
          mode="indeterminate"
          [diameter]="30"
          class="spinner"
        ></mat-progress-spinner>
      </div>
    </div>

    <div class="title-violation_block" *ngIf="violations.length">Violations</div>

    <div class="container-table" *ngIf="violations.length">
      <table mat-table [dataSource]="violations">
        <ng-container matColumnDef="violationSequenceId">
          <th mat-header-cell *matHeaderCellDef>Unit #</th>
          <td mat-cell *matCellDef="let element">{{ element?.violationSequenceId }}</td>
        </ng-container>

        <ng-container matColumnDef="vehicleUnitCode">
          <th mat-header-cell *matHeaderCellDef>Code</th>
          <td mat-cell *matCellDef="let element">{{ element?.vehicleUnitCode }}</td>
        </ng-container>

        <ng-container matColumnDef="violationCategory">
          <th mat-header-cell *matHeaderCellDef>Category</th>
          <td mat-cell *matCellDef="let element">{{ element?.violationCategory }}</td>
        </ng-container>

        <ng-container matColumnDef="violationDescription">
          <th mat-header-cell *matHeaderCellDef>Viol Description</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.violationDescription }}
          </td>
        </ng-container>

        <ng-container matColumnDef="stateCitationNumber">
          <th mat-header-cell *matHeaderCellDef>Citation #</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.stateCitationNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="violationOosFlag">
          <th mat-header-cell *matHeaderCellDef>Out of Service</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.violationOosFlag | titlecase }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="violationColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: violationColumns"></tr>
      </table>
    </div>

    <div class="title-violation_block">Hazmat</div>
    <p class="hazmat-description">No HM Transported.</p>
  </div>
</mat-dialog-content>
